import StateHandler from "src/states/StateHandler"

class BasicStateHandler implements StateHandler {
    states: any = {}

    constructor(initialStates: any = {}) {
        this.states = initialStates
    }

    set(id: string, state: any) {
        this.states[id] = state
    }

    get(id: string) {
        return this.states[id]
    }
}

export default BasicStateHandler
